import * as Sentry from "@sentry/react";
import { TRACE_PROPAGATION_TARGETS } from "./sentryTargets";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
const environment = import.meta.env.MODE ?? "development";
const release = import.meta.env.VITE_SENTRY_RELEASE;

if (!SENTRY_DSN && import.meta.env.DEV) {
  console.warn("[Sentry] VITE_SENTRY_DSN not set — client-side monitoring disabled.");
}

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment,
    release,
    enableLogs: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracePropagationTargets: TRACE_PROPAGATION_TARGETS,
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    replaysSessionSampleRate: import.meta.env.PROD ? 0.05 : 1.0,
    replaysOnErrorSampleRate: 1.0,
  });

  Sentry.setTag("app", "recruit-ai-react");
  Sentry.logger.info("sentry_initialized", { environment, release });
}
